import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import { Font } from '@react-pdf/renderer';
import {style} from '../../../components/pdf/fontstyles';



const styles = StyleSheet.create({
        page: {
            padding: 10, // Reduce padding
      
            fontSize: 10,
            marginLeft: 40,
            marginRight: 40,
            marginTop: 10,
            marginBottom: 10,
            lineHeight: 1.5,

          },
          solidLine: {
           
            borderBottomWidth: 1,   // thickness of the line
            borderBottomColor: '#000', // color (black here)
            width: '100%',         // full width of page or container
          },
          
          title: {
            fontSize: 14, 
            marginBottom: 10, 
            textAlign: 'center',
            fontWeight: 'bold', 
          },
          subhead: {
            fontSize: 10,
            textAlign: 'center',
          },
          paragraph: {
            fontSize: 10,
            marginBottom: 5, 
            textAlign: 'justify',
          },


  // Main table styles
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  cell: {
    padding: 5,
    borderRight: '1px solid #000',
    verticalAlign: 'middle',
  },
  srNoCell: {
    width: '5%',
  },
  detailsCell: {
    width: '55%',
  },
  pageNoCell: {
    width: '40%',
  },
  // Special merged cell for row 18
  mergedCell: {
    padding: 5,
    width: '95%', // 55% + 40%
    borderRight: 'none', // Remove right border
  },

  // Nested table styles
  nestedTable: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    borderCollapse: 'collapse',
    marginTop: 5,
    marginBottom: 5,
  },
  nestedRow: {
    flexDirection: 'row',
  },
  nestedHeaderCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
    padding: 3,
    textAlign: 'center',
    borderRight: '1px solid #000',
    borderBottom: '1px solid #000',
    fontSize: 8,
  },
  nestedCell: {
    padding: 3,
    borderRight: '1px solid #000',
    borderBottom: '1px solid #000',
    textAlign: 'center',
    fontSize: 8,
  },
  // Equal width for all 6 columns
  // nestedCol: {
  //   width: '16.66%',
  // },
  nestedCol1: { width: '10%' },  
  nestedCol2: { width: '40%',textAlign: 'left' },   
  nestedCol3: { width: '15%' },  
  nestedCol4: { width: '35%' },  
  });


        
        const Form6Part1P3 = ({ result }) => {
          // Make sure childDetails exists and initialize it as an array if it doesn't
          const childDetails = result?.childDetails || [];
          const basicPay = result?.basicPay || 0;
          
          const tableData = [

            ['25', 
              `Whether nomination made for 
               i)	Death Cum retirement gratuity.
               ii)	Family pension, 1950 if applicable `,
               `
                Yes
                Yes`
             ],

            ['26',
             `Whether Family pension, 1964 applies to the Government servant  and if so.
            • pay reckoning for the family pension
              a)	Calculation of family pension 
                i)	Pay last drawn
                ii)	50% fo pay last drawn
                iii)	30% of Pay last drawn subject to minimum of Rs.1250/- and Maximum of 
                iv)	Family Pension Proposed
            •	The amount of the family Pension becoming payable to the family of the Government servant, death takes place after retirement-
                a)	before attaining the age of 70 year or 
                b)	after attaining the age of 70 year
            • Complete and up-to-date details of the family as `,
              `
              Yes
              ${basicPay}
              
              ${basicPay}
              ${Math.round(basicPay / 2)}

              ${Math.round(basicPay * 0.3)}
              ${Math.round(basicPay * 0.3)}
              
              
              
              ${Math.round(basicPay / 2)}
              ${Math.round(basicPay * 0.3)}
            given in form 3 given below.`
            ],

            ['', 
              (
                <View style={{ flexDirection: 'column' }}>
                  <Text>Family Details:</Text>
                  
                  {/* Nested Table Container - spans columns 2+3 */}
                  <View style={styles.nestedTable}>
                    {/* Header Row */}
                    <View style={styles.nestedRow}>
                      <Text style={[styles.nestedHeaderCell, styles.nestedCol1]}>Sr. no.</Text>
                      <Text style={[styles.nestedHeaderCell, styles.nestedCol2]}>Name of the member of Family</Text>
                      <Text style={[styles.nestedHeaderCell, styles.nestedCol3]}>Date of birth</Text>
                      <Text style={[styles.nestedHeaderCell, styles.nestedCol4]}>Relationship with the employee.</Text>
                
                    </View>
                    
                    {/* Data Rows */}
                    <View style={styles.nestedRow}>
                    <Text style={[styles.nestedCell, styles.nestedCol1]}>1</Text>
                      <Text style={[styles.nestedCell, styles.nestedCol2]}>{result?.spouseName || '--'}</Text>
                      <Text style={[styles.nestedCell, styles.nestedCol3]}>{result?.spouseDOB || '--'}</Text>
                      <Text style={[styles.nestedCell, styles.nestedCol4]}>{result?.spouceRelation || '--'}</Text>
                    </View>
                    
                    <View style={styles.nestedRow}>
                      <Text style={[styles.nestedCell, styles.nestedCol1]}>2</Text>
                      <Text style={[styles.nestedCell, styles.nestedCol2]}>{childDetails[0]?.nameChild || '--'}</Text>
                      <Text style={[styles.nestedCell, styles.nestedCol3]}>{childDetails[0]?.dobChild || '--'}</Text>
                      <Text style={[styles.nestedCell, styles.nestedCol4]}>{childDetails[0]?.relationship || '--'}</Text>
                    </View>
                    
                    <View style={styles.nestedRow}>
                      <Text style={[styles.nestedCell, styles.nestedCol1]}>3</Text>
                      <Text style={[styles.nestedCell, styles.nestedCol2]}>{childDetails[1]?.nameChild || '--'}</Text>
                      <Text style={[styles.nestedCell, styles.nestedCol3]}>{childDetails[1]?.dobChild || '--'}</Text>
                      <Text style={[styles.nestedCell, styles.nestedCol4]}>{childDetails[1]?.relationship || '--'}</Text>
                    </View>
                  </View>
                </View>
              ),
            ],
            ['27', 
              'Height',
              result?.Height || '--'
            ],
            ['28', 
              'Identification marks',
              result?.splMark || '--'
            ],
            ['29', 
              'Place of payment of pension',
              result?.treasury || '--'
            ],
            ['30',
              'Head of Account to which pension (Government Treasury or Branch of  Public-sector Bank)Gratuity are debitable',
               `${result?.bankName || '--'} , 
              Branch: ${result?.branchName || '--'}, , 
              IFCS: ${result?.ifscCode || '--'}, 
              Ac. No.:${result?.accountNumber || '--'}`
            ],
            ['31', 
              'If pension/ D.C.R.G. already sanctioned previously (sanctioned No. and date of Audit office) Amount of pension and D.C.R.G may be adjusted.',
              'Not sanctioned previously.'
            ]
          ];
        
          return (
            <View size="A4" style={styles.page}> 
              <View style={styles.table}>
                {tableData.map(([srNo, details, value], index) => (
                  <View style={styles.row} key={index}>
                    <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
                    
                    {srNo === '' ? (
                      <View style={styles.mergedCell}>
                        {details}
                      </View>
                    ) : (
                      <>
                        <Text style={[styles.cell, styles.detailsCell]}>{details}</Text>
                        <Text style={[styles.cell, styles.pageNoCell]}>{value}</Text>
                      </>
                    )}
                  </View>
                ))}
              </View>

             <Text style={[ style.ArialItalic,style.signature , {marginTop: 50}]}>Head of Office</Text>
              
            </View>
          );
        };
        
        export default Form6Part1P3;